export function init($name) {
    const elem = $($name);

    if (!elem.length) {
        return;
    }

    elem.click(function(e) {
        e.preventDefault();
        e.stopPropagation();

        $(this).toggleClass('is-showed');
        $(this).next($name + '-elem').toggleClass('is-showed');
    });

    $($name + '-elem').click(function(e) {
       e.stopPropagation();
    });

    $('body').click(function() {
        $(this).find($name).removeClass('is-showed');
        $(this).find($name + '-elem').removeClass('is-showed');
    });
}

export function scroll($name) {
    const elem = $($name);

    if (!elem.length) {
        return;
    }

    const getCookieValue = $.cookie("cookieShowedGroup");
    let seen = false;

    elem.each(function() {
       if ($(this).hasClass('current-menu-item')) {
           if (getCookieValue !== "true") {
               $.cookie("cookieShowedGroup", "true", { expires: 7, path: '/' });
           } else {
               $('html, body').animate({scrollTop: $('#scrollPage').children().first().outerHeight() - 80 - $('header#header').find('.main-sec-navigation').first().outerHeight()}, 500);
           }
           seen = true;
       }
    });

    if (!seen) {
        $.cookie("cookieShowedGroup", null, { expires: 7, path: '/' });
    }
}
